import { MerchantCategory } from '@nemuru-eng/js-api-client';

export const getMerchantVerticalByMerchantCategory = (merchantCategory: MerchantCategory) => {
  switch (merchantCategory) {
    case MerchantCategory.OTHER:
      return MerchantVertical.NULL;
    case MerchantCategory.CAR_DEALERSHIPS:
    case MerchantCategory.MOTO_DEALERSHIPS:
      return MerchantVertical.AUTO;
    case MerchantCategory.FP_PROGRAMS:
    case MerchantCategory.BOOTCAMP_COURSES:
    case MerchantCategory.SCHOOL:
    case MerchantCategory.OTHER_PROFESSIONAL_COURSES:
    case MerchantCategory.BUSINESS_SCHOOLS_PROGRAMS:
    case MerchantCategory.LANGUAGES_COURSES:
    case MerchantCategory.POSTGRADUATE_AND_MASTERS:
    case MerchantCategory.DRIVING_COURSES:
    case MerchantCategory.EDUCATION_AND_TRAININGS:
      return MerchantVertical.EDUCATION;
    case MerchantCategory.OTHER_SURGERY_INTERVENTIONS:
    case MerchantCategory.COSMETIC_SURGERY:
    case MerchantCategory.DENTAL_TREATMENTS:
    case MerchantCategory.AUDITORY_PROTHESIS:
    case MerchantCategory.COSMETIC_TREATMENTS:
    case MerchantCategory.ORTHOPEDIC_EQUIPMENT:
    case MerchantCategory.REHABILITATION:
    case MerchantCategory.FERTILITY_TREATMENT:
    case MerchantCategory.OPTICAL_PROSTHESIS:
      return MerchantVertical.HEALTH;
    case MerchantCategory.CARPENTRY:
    case MerchantCategory.WHOLE_HOUSE:
    case MerchantCategory.PAINTING:
    case MerchantCategory.BATHROOMS:
    case MerchantCategory.GARDENING:
    case MerchantCategory.KITCHEN:
    case MerchantCategory.HOME_AUTOMATION:
    case MerchantCategory.INSULATION:
    case MerchantCategory.STRUCTURE_AND_HUMIDITY:
    case MerchantCategory.WAREHOUSE:
    case MerchantCategory.ARCHITECTURE:
    case MerchantCategory.DECORATION_AND_DESIGN:
    case MerchantCategory.TERRACE_AND_AWNINGS:
    case MerchantCategory.FLOORS_AND_CEILINGS:
    case MerchantCategory.POOLS:
    case MerchantCategory.HOME_STAGING:
    case MerchantCategory.FURNITURE:
    case MerchantCategory.WINDOWS:
    case MerchantCategory.PREFABRICATED_HOUSES:
      return MerchantVertical.HOME;
    case MerchantCategory.ELECTRIC_INSTALLATIONS:
    case MerchantCategory.ECO_IMPROVEMENT_AND_SOLAR_PANELS:
    case MerchantCategory.HEATING_INSTALLATIONS:
    case MerchantCategory.ALARMS_AND_SECURITY:
    case MerchantCategory.AIR_TREATMENTS:
    case MerchantCategory.WATER_TREATMENT:
    case MerchantCategory.INSTALLATIONS:
    case MerchantCategory.CHARGING_POINTS:
      return MerchantVertical.INSTALLATION;
    case MerchantCategory.BIKE:
    case MerchantCategory.OTHER_MOBILITY_AND_ACCESSORIES:
    case MerchantCategory.CAR_SERVICE:
    case MerchantCategory.CAR_TUNING:
    case MerchantCategory.MOTO_SERVICE:
      return MerchantVertical.MOBILITY;
    case MerchantCategory.REAL_ESTATE_AND_RENTALS:
    case MerchantCategory.RELOCATION:
    case MerchantCategory.FUNERAL_SERVICES:
    case MerchantCategory.CELEBRATIONS:
    case MerchantCategory.PET_SHOPS:
      return MerchantVertical.OTHERS;
    case MerchantCategory.ELECTRONIC:
    case MerchantCategory.HOUSEHOLD_APPLIANCES:
    case MerchantCategory.GYM_ACCESSORIES:
    case MerchantCategory.ART:
    case MerchantCategory.LIGHTING:
    case MerchantCategory.JEWELLERY:
    case MerchantCategory.FASHION:
    case MerchantCategory.PERFUMERY_AND_COSMETICS:
    case MerchantCategory.GARDEN_MACHINES:
      return MerchantVertical.RETAIL;
    case MerchantCategory.TRAVELS:
      return MerchantVertical.TRAVEL_AND_LEISURE;
    default:
      return MerchantVertical.OTHERS;
  }
};

export enum MerchantVertical {
  NULL = 'null',
  AUTO = 'auto',
  EDUCATION = 'education',
  HEALTH = 'health',
  HOME = 'home',
  INSTALLATION = 'installation',
  MOBILITY = 'mobility',
  OTHERS = 'others',
  RETAIL = 'retail',
  TRAVEL_AND_LEISURE = 'travel_and_leisure',
}
